import React from 'react';
import styles from './Button.module.css';

function ActionButton({ clickHandler, children, type = 'button' }) {
    return (
        <button className={styles.button} onClick={clickHandler} type={type}>
            {children}
        </button>
    );
}

export default ActionButton;
